import { create } from 'zustand';

import type { Blast } from '~api/services';

type BlastStore = {
  /** Currently selected blast */
  selectedBlast: Blast | null;
  /** Sets the selected blast in the store */
  setSelectedBlast: (blast: Blast | null) => void;
  /** Clears the selected blast from the store */
  clearSelectedBlast: () => void;
};

const useBlastStore = create<BlastStore>((set, _get) => ({
  selectedBlast: null,

  setSelectedBlast: (blast: Blast | null) => set({ selectedBlast: blast }),

  clearSelectedBlast: () => set({ selectedBlast: null }),
}));

export { useBlastStore };
